import { useState } from "react";
import "./MDLHeader.scss";
import { useLocation, useNavigate } from "react-router-dom";
import {
MenuOutlined
} from '@ant-design/icons';

const MDLHeader = (props: { height: string }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [selectedItem, setSelectedItem] = useState("home");
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navItemsConfig = [
    { id: "vision", text: "Vision & Mission" },
    { id: "team", text: "Unser Team" },
    { id: "about", text: "Über uns" },
  ];

  const handleNavClick = (itemId: string) => {
    navigate(itemId);
    setSelectedItem(itemId);
    setMobileMenuOpen(false);
  };

  return (
    <>
      <div
        id="mdl-header-logo"
        onClick={() => {
          handleNavClick("home");
        }}
      >
        <img style={{ height: "100%" }} src="./mdl_logo.png" />
      </div>
      <div id="mdl-header" style={{ height: props.height }}>
        <div id="mdl-header-menu">
          {navItemsConfig.map((item) => (
            <div
              id={"mdl-header-menu-item-" + item.id}
              key={"mdl-header-menu-item-" + item.id}
              className={
                "mdl-header-menu-item" +
                (selectedItem === item.id ? " selected" : "")
              }
              onClick={() => handleNavClick(item.id)}
            >
              {item.text}
            </div>
          ))}
        </div>
        <MenuOutlined
          id="sandwich-menu-icon"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        />
      </div>
      <div id="mdl-mobile-menu" className={mobileMenuOpen ? "open" : ""}>
        {navItemsConfig.map((item) => (
          <div
            id={"mdl-mobile-menu-item-" + item.id}
            key={"mdl-mobile-menu-item-" + item.id}
            className={
              "mdl-mobile-menu-item" +
              (selectedItem === item.id ? " selected" : "")
            }
            onClick={() => handleNavClick(item.id)}
          >
            {item.text}
          </div>
        ))}
      </div>
    </>
  );
};

export default MDLHeader;
